/* eslint-disable @ms/forbid-file-names */
import type { CurrentNetworkContext } from '@ms/yammer-data/dist/state/types';
import type { Basename } from '@ms/yammer-libs-url-path-support';
import { basenameForWebApp } from '@ms/yammer-libs-url-path-support';

export interface GetBaseUrlProps {
  readonly currentNetworkContext?: CurrentNetworkContext;
  readonly host?: string;
  readonly basename?: Basename;
}
export type GetBaseUrl = (props?: GetBaseUrlProps) => string;

export const getBaseUrl: GetBaseUrl = (props) => {
  const protocol = window.location.protocol;
  const host = props?.host && window.location.host !== props.host ? props.host : window.location.host;
  const baseUrl = `${host}${props?.basename ?? basenameForWebApp}`;

  if (props?.currentNetworkContext?.networkPath) {
    return `${protocol}//${baseUrl}/${props.currentNetworkContext?.networkPath}`;
  }

  return `${protocol}//${baseUrl}`;
};
